import React from 'react';
/**
 * data Columns for grid and mobile view
 * @type {React.FC<Props>}
 * @returns {React.ReactElement} The Data Columns Array
 */
export const DataColumns = ({
  MultiViewCalenderFilterCell,
  dateRangeFilter,
  GridDateCell,
  setDateRangeFilter,
  GridFlag,
  BooleanFlagFilterCell,
}) => {
  const dataColumns = [
    {
      field: 'UserId',
      title: 'User Id',
      editable: false,
      show: false,
      width: '250px',
      width: '250px',
      minResizableWidth: 150,
      excludeFromFilter: true,
      filterable: false,
    },
    {
      field: 'Username',
      title: 'User Name',
      editable: false,
      show: true,
      width: '250px',
      minResizableWidth: 50,
      filterable: true,
    },
    {
      field: 'EmailAddress',
      title: 'Email Address',
      editable: false,
      show: true,
      width: '250px',
      minResizableWidth: 150,
      filterable: true,
    },
    {
      field: 'FirstName',
      title: 'First Name',
      editable: false,
      show: true,
      width: '250px',
      minResizableWidth: 50,
      filterable: true,
    },
    {
      field: 'LastName',
      title: 'Last Name',
      editable: false,
      show: true,
      width: '250px',
      minResizableWidth: 50,
      filterable: true,
    },
    {
      field: 'Active',
      title: 'Active',
      editable: false,
      show: true,
      width: '150px',
      minResizableWidth: 50,
      cell: GridFlag,
      filterCell: BooleanFlagFilterCell,
      filterable: true,
    },
    {
      field: 'CreatedBy',
      title: 'Created By',
      editable: false,
      show: false,
      width: '200px',
      minResizableWidth: 50,
      filterable: true,
      excludeFromFilter: true,
    },
    {
      field: 'CreatedDate',
      title: 'Created Date',
      editable: false,
      show: false,
      width: '300px',
      minResizableWidth: 50,
      filter: 'date',
      type: 'dateRange',
      filterCell: (props) =>
        MultiViewCalenderFilterCell({
          ...props,
          dateRangefilter: dateRangeFilter,
          setDateRangeFilter,
          field: 'CreatedDate',
        }),
      isRequired: true,
      cell: GridDateCell,
      filterable: true,
      excludeFromFilter: true,
    },
    {
      field: 'ModifiedBy',
      title: 'Modified By',
      editable: false,
      show: false,
      width: '200px',
      minResizableWidth: 50,
      filterable: true,
      excludeFromFilter: true,
    },
    {
      field: 'ModifiedDate',
      title: 'Modified Date',
      editable: false,
      show: false,
      width: '300px',
      minResizableWidth: 50,
      filter: 'date',
      type: 'dateRange',
      filterCell: (props) =>
        MultiViewCalenderFilterCell({
          ...props,
          dateRangefilter: dateRangeFilter,
          setDateRangeFilter,
          field: 'ModifiedDate',
        }),
      isRequired: true,
      cell: GridDateCell,
      filterable: true,
      excludeFromFilter: true,
    },
  ];

  return dataColumns;
};
export default DataColumns;
